import { useMemo } from 'react';
import style from './useFootnotes.module.scss';
type SymbolNote = { symbol: string; description: string };
type ClassNote = { className: string; id?: string; description: string };
export type NoteInfo = SymbolNote | ClassNote;
export type Selector<T> = (item: T) => NoteInfo | null;

export function useFootnotes<T>(data: T[], select: Selector<T>) {
    const distinct = useMemo(
        () => (data.map(select).filter((m, i, arr) => arr.findIndex((itm) => areEqual(itm, m)) == i) as NoteInfo[]).sort(bySymbol),
        [data, select]
    );
    const List = (
        <ul className={style.root}>
            {distinct.map((itm, i) => (
                <li key={i}>
                    <StatusIcon note={itm} />
                    <span>{itm.description}</span>
                </li>
            ))}
        </ul>
    );
    const symbols = distinct.map((itm) => (isSymbol(itm) ? itm.symbol : itm.className));

    return [List, symbols];
}

export function StatusIcon({ note: info }: { note: NoteInfo | null }) {
    return info ? (
        isSymbol(info) ? (
            <span className={style.symbol} title={info.description}>{info.symbol}</span>
        ) : (
            <div className={style.classNote} title={info.description}>
                <span className={info.className}></span>
                <span>{info.id}</span>
            </div>
        )
    ) : null;
}

function bySymbol(a: NoteInfo, b: NoteInfo) {
    const valA = isSymbol(a) ? a.symbol : a.className;
    const valB = isSymbol(b) ? b.symbol : b.className;
    if (valA < valB) {
        return -1;
    }
    if (valA > valB) {
        return 1;
    }
    return 0;
}

export function isSymbol(info: NoteInfo | null): info is SymbolNote {
    return info != null && 'symbol' in info;
}
export function isClass(info: NoteInfo | null): info is ClassNote {
    return info != null && 'className' in info;
}
function areEqual(a: NoteInfo | null, b: NoteInfo | null) {
    if (isSymbol(a) && isSymbol(b)) {
        return a.symbol == b.symbol;
    }
    if (isClass(a) && isClass(b)) {
        return a.className == b.className && a.id == b.id;
    }
    return false;
}
